module.exports = __webpack_public_path__ + "static/media/1POLICY29.8da8a61c.jpg";